import { type ChatEventType, EVENT_TYPE_DEFAULT_MESSAGES } from 'constants/chat-event-type';
import { UNNAMED_AUTHOR } from 'constants/localization';

export function getDefaultMessageForEventType(type: ChatEventType, authorName: string = UNNAMED_AUTHOR): string {
  const getter = EVENT_TYPE_DEFAULT_MESSAGES[type];

  return getter ? getter(authorName) : null;
}
